export default "<m-plane\n    y=\"5\"\n    sx=\"5\"\n    sy=\"7\"\n    color=\"pink\"\n></m-plane>\n";